var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormatPainter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 35",
    clipPath: "url(#clip0_44_1418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4800"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M9.45366 4.65217L9.10011 5.00572L9.45366 5.35927L9.80722 5.00572L9.45366 4.65217ZM1.10097 7.61318L0.747412 7.25962L0.393859 7.61318L0.747412 7.96673L1.10097 7.61318ZM8.65817 15.1704L8.30462 15.5239L8.65817 15.8775L9.01172 15.5239L8.65817 15.1704ZM11.575 6.77349L11.2214 6.41993L10.8679 6.77349L11.2214 7.12704L11.575 6.77349ZM12.9752 1.83777L12.9752 1.83777L13.6823 1.13066C13.2918 0.740135 12.6586 0.740134 12.2681 1.13066L12.9752 1.83777ZM9.80722 5.00572L12.9752 1.83777L12.2681 1.13066L9.10011 4.29861L9.80722 5.00572ZM6.75782 2.66343L9.10011 5.00572L9.80722 4.29861L7.46493 1.95632L6.75782 2.66343ZM6.75782 2.66343L7.46493 1.95632C7.0744 1.5658 6.44124 1.5658 6.05071 1.95632L6.75782 2.66343ZM1.45452 7.96673L6.75782 2.66343L6.05071 1.95632L0.747412 7.25962L1.45452 7.96673ZM9.01172 14.8168L1.45452 7.25962L0.747412 7.96673L8.30462 15.5239L9.01172 14.8168ZM13.6079 9.51353L8.30462 14.8168L9.01172 15.5239L14.315 10.2206L13.6079 9.51353ZM13.6079 9.51353L14.315 10.2206C14.7055 9.83011 14.7055 9.19694 14.315 8.80642L13.6079 9.51353ZM11.2214 7.12704L13.6079 9.51353L14.315 8.80642L11.9285 6.41993L11.2214 7.12704ZM14.3894 3.25198L11.2214 6.41993L11.9285 7.12704L15.0965 3.95909L14.3894 3.25198ZM14.3894 3.25198L14.3894 3.25198L15.0965 3.95909C15.487 3.56856 15.487 2.9354 15.0965 2.54487L14.3894 3.25198ZM12.9752 1.83777L14.3894 3.25198L15.0965 2.54487L13.6823 1.13066L12.9752 1.83777Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 701",
    d: "M4.62247 4.18005L12.0471 11.6047",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 702",
    d: "M2.85469 9.30656L4.40149 7.75977",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 703",
    d: "M7.09734 13.5492L8.64413 12.0024",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 704",
    d: "M4.88763 11.3395L7.18573 9.04144",
    stroke: "#626262"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_1418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatPainter);
export default __webpack_public_path__ + "static/media/format-painter.8b562eb73f82dc809d306e23997c4655.svg";
export { ForwardRef as ReactComponent };